var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zoom",on:{"click":_vm.bigSmall}},[(!_vm.isBigBool)?_c('Icon',{attrs:{"type":"md-expand"}}):_vm._e(),(_vm.isBigBool)?_c('Icon',{attrs:{"type":"md-contract"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }